import React from 'react';
import PopoverItem from './popovers/PopoverItem'
import PrintTablePopoverItem from './popovers/PrintTablePopoverItem'
import DocumentTypeTablePopoverItem from './popovers/DocumentTypeConfigPopoveritem'
import EditorPopoverItem from './popovers/EditorPopoverItem'
import PollerPopoverItem from './popovers/PollerPopoverItem'
import SMTPConfigTablePopover from './popovers/SMTPConfigTablePopover';
import { Button, Input, UncontrolledTooltip } from 'reactstrap';
import moment from 'moment'
import { Flag } from 'flagger/react';

class Row extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            expandOpen: false
        };

        this.drop = this.drop.bind(this);
        this.allowDrop = this.allowDrop.bind(this);
        this.toggleExpand = this.toggleExpand.bind(this);
    }


    toggleExpand(file) {
        this.setState({
            expandOpen: !this.state.expandOpen
        });

        this.props.expandLogs(file);
    }

    drop(event) {
        event.preventDefault();
    }

    allowDrop(event) {
        event.preventDefault();
    }

    statusPillClass(status) {
        const s = String(status).toLowerCase();
        if (["complete", "completed", "success", "ok", "active", "running"].includes(s)) return "s-status-success";
        if (["pending", "inprogress", "processing"].includes(s)) return "s-status-warning";
        if (["error", "failed"].includes(s)) return "s-status-error";
        if (s === "info") return "s-status-info";
        return "s-status-default";
    }

    render() {

        const { checked, editorpopover, printeditorpopover, documentTypeEditorPopover, parentRow, pollerPopover, smtpconfigpopover, columnConfig} = this.props
        let action_cell = {}
        let date_row = []

        const legacy = !columnConfig;
        const showExpand = columnConfig?.expand ?? (this.props.editorpopover || this.props.parentRow || this.props.logsRow);
        const showActions = columnConfig?.actions ?? (!checked && !editorpopover && !printeditorpopover && !documentTypeEditorPopover && !pollerPopover && !smtpconfigpopover);
        const showCheckbox = columnConfig?.checkbox ?? (!showActions && !legacy ? true : false);

        if (this.props.dated) {
            date_row.push(<td className={this.props.rightAlign.includes(6) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid)}>
                <div class="s-inplace-value-read">
                    {moment(this.props.dated).isValid() ?
                        <p class="s-inplace-link">{moment(this.props.dated).format('HH:mm DD/MM/YY')}</p>
                        :
                        <p class="s-inplace-link">{this.props.dated}</p>
                    }
                </div>
            </td>)
        }

            if (parentRow) {
                action_cell = 
                <PopoverItem
                    viewPortfolio={this.props.viewPortfolio}
                    refresh={this.props.refresh}
                    id={this.props.id}
                    fileid={this.props.fileid}
                    file={this.props.file}
                    filename={this.props.filename}
                    filetype={this.props.filetype}
                    disabled={this.props.version === '0'}
                />
            }
            else if (!checked && !editorpopover && !printeditorpopover && !documentTypeEditorPopover && !pollerPopover && !smtpconfigpopover) {
                action_cell = 
                    <PopoverItem
                        viewPortfolio={this.props.viewPortfolio}
                        refresh={this.props.refresh}
                        id={this.props.id}
                        fileid={this.props.fileid}
                        file={this.props.file}
                        filename={this.props.filename}
                        filetype={this.props.filetype}
                        disabled={this.props.version === '0'}
                    />
            }
            else if (editorpopover) {
                action_cell = 
                    <EditorPopoverItem
                        refresh={this.props.refresh}
                        editorpopoverchild={this.props.editorpopoverchild}
                        id={this.props.id}
                        fileid={this.props.fileid}
                        file={this.props.file}
                        filename={this.props.filename}
                        filetype={this.props.filetype}
                        useFilteredTemplates={this.props.useFilteredTemplates} 
                    />
            }
            else if (printeditorpopover) {
                action_cell = 
                    <PrintTablePopoverItem
                        viewPortfolio={this.props.viewPortfolio}
                        refresh={this.props.refresh}
                        id={this.props.id}
                        fileid={this.props.fileid}
                        file={this.props.file}
                        filename={this.props.filename}
                        filetype={this.props.filetype}
                    />
            }
            else if (documentTypeEditorPopover) {
                action_cell = 
                    <DocumentTypeTablePopoverItem
                        viewPortfolio={this.props.viewPortfolio}
                        refresh={this.props.refresh}
                        id={this.props.id}
                        fileid={this.props.fileid}
                        file={this.props.file}
                        filename={this.props.filename}
                        filetype={this.props.filetype}
                    />
            }
            else if (pollerPopover) {
                action_cell = 
                    <PollerPopoverItem
                        viewPortfolio={this.props.viewPortfolio}
                        refresh={this.props.refresh}
                        id={this.props.id}
                        type={this.props.pollerType}
                        fileid={this.props.fileid}
                        file={this.props.file}
                        filename={this.props.filename}
                        filetype={this.props.filetype}
                    />
            }
            else if (smtpconfigpopover) {
                action_cell = 
                    <SMTPConfigTablePopover
                        refresh={this.props.refresh}
                        id={this.props.id}
                        settings={this.props.file}
                        fileid={this.props.fileid}
                        settingsId={this.props.i} 
                        type={this.props.filename}
                        emailConfig={this.props.emailConfig}
                        isDefault={this.props.isDefault}
                        onRowClicked={this.onRowClicked}
                    />
            }

       
        const checkboxNode = (showCheckbox || this.props.pollerPopover) ? (
            <Input
                checked={this.props.is_checked}
                onChange={() => this.props.checkChange(this.props.fileid)}
                className="table-row-checkbox"
                type="checkbox"
                style={{ marginTop: ".3rem !important" }}
            />
        ) : null;

        return (
            <tr class={this.props.tr_css}  
            onDrop={this.drop} 
            onDragOver={this.allowDrop} 
            style={this.props.onRowClicked && { cursor: 'pointer' }}
            >
                {/* Expand column (only if enabled and this row actually has children) */}
                {showExpand ? (
                <td className="s-grid-cell s-grid-actions-cell">
                    {(this.props.editorpopoverchild) ? null : (
                    <Button
                        className="s-record-picker s-fonticon-btn s-btn-menus"
                        color="secondary"
                        onClick={() => this.toggleExpand(this.props.file)}
                    >
                        {this.props.expandOpen ? '' : ''}
                    </Button>
                    )}
                </td>
                ) : null}

                {showCheckbox ? (
                <td className="s-grid-cell s-grid-actions-cell">{checkboxNode}</td>
                ) : null}

                {showActions ? (
                <td className="s-grid-cell s-grid-actions-cell">{action_cell}</td>
                ) : null}
                <Flag flag="SecondReferenceField" entity={{ id: 1 }} case="on">
                    {this.props.fileTable &&
                        <td className={this.props.rightAlign.includes(1) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                            <div class="s-inplace-value-read">
                                <p class="s-inplace-link">{this.props.file.SecondRef}</p>
                            </div>
                        </td>
                    }
                </Flag>
                {this.props.smtpconfigpopover 
                ? (
                    <td className={this.props.rightAlign.includes(1) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                    <div class="s-inplace-value-read">
                        <p class="s-inplace-link">{this.props.emailConfig}</p>
                    </div>
                </td>
                )                 
                : (<div style={{ display: 'none' }} />)}
                <td className={this.props.rightAlign.includes(1) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                    <div class="s-inplace-value-read">
                        <p class="s-inplace-link">{this.props.filename}</p>
                    </div>
                </td>
                <Flag flag="SecondReferenceField" entity={{ id: 2 }} case="on">
                    {this.props.fileTable &&
                        <td className={this.props.rightAlign.includes(1) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                            <div class="s-inplace-value-read">
                                <p class="s-inplace-link">{this.props.file.SecondRef}</p>
                            </div>
                        </td>
                    }
                </Flag>

                <td className={this.props.rightAlign.includes(2) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                    <div class="s-inplace-value-read">
                        {this.props.filetypeIsStatus ? (
                            <span className={`s-status-pill ${this.statusPillClass(this.props.filetypedesc || this.props.filetype)}`}>
                                {this.props.filetypedesc || this.props.filetype}
                            </span>
                        ) : (
                            <p class="s-inplace-link">{this.props.filetypedesc || this.props.filetype}</p>
                        )}
                    </div>
                </td>
                {this.props.description &&
                    <td className={"s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                        <div class="s-inplace-value-read" >
                            <p class="s-inplace-link" id={"descfield-" + this.props.fileid}>{this.props.description}</p>
                            <UncontrolledTooltip placement="bottom" target={"descfield-" + this.props.fileid}>
                                {this.props.description}
                            </UncontrolledTooltip>
                        </div>
                    </td>
                }
                {this.props.version ? (
                    <td className={this.props.rightAlign.includes(3) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                        <div class="s-inplace-value-read">
                            <p class="s-inplace-link">{this.props.version}</p>
                        </div>
                    </td>) : (<div style={{ display: 'none' }} />
                )}
                <td className={this.props.rightAlign.includes(4) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                    <div class="s-inplace-value-read">
                        <p class="s-inplace-link">{this.props.user}</p>
                    </div>
                </td>
                {this.props.state &&
                    <td className={this.props.rightAlign.includes(5) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                        <div class="s-inplace-value-read">
                            <span className={`s-status-pill ${this.statusPillClass(this.props.state)}`}>{this.props.state}</span>
                        </div>
                    </td>
                }
                {date_row}
                {this.props.folder && (
                    <td
                        className={
                        this.props.rightAlign.includes(7)
                            ? "s-grid-cell s-inplace s-grid-cell-right"
                            : "s-grid-cell s-inplace s-grid-cell-left"
                        }
                        onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}
                    >
                        <div className="s-inplace-value-read">
                        <p className="s-inplace-link">{this.props.folder}</p>
                        </div>
                    </td>
                    )}
                {this.props.smtpconfigpopover 
                ? (
                    <td className={this.props.rightAlign.includes(1) ? "s-grid-cell s-inplace s-grid-cell-right" : "s-grid-cell s-inplace s-grid-cell-left"} onClick={() => this.props.onRowClicked(this.props.fileid, this.props.file)}>
                    <div class="s-inplace-value-read">
                        <p class="s-inplace-link">{this.props.isDefault ? "true" : "false"}</p>
                    </div>
                </td>
                ) 
                : (<div style={{ display: 'none' }} />)}
            </tr>
        );
    }
}

export default Row;